import { Schema, type } from "@colyseus/schema"
import { defaultCardSrc } from "../../consts"

export const cardSuits = ["heart", "diamond", "club", "spade"] as const
export type CardSuit = (typeof cardSuits)[number]
export const cardMinimumValue = 2
export const cardType = [
  "two",
  "three",
  "four",
  "five",
  "six",
  "seven",
  "eight",
  "nine",
  "ten",
  "jack",
  "queen",
  "king",
  "ace",
] as const

export type CardType = (typeof cardType)[number]

export const cardPowers = [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14] as const

export type CardPower = (typeof cardPowers)[number]

export class CardDataClass extends Schema {
  @type("string") cardSuit!: CardSuit
  @type("string") cardType!: CardType
  @type("number") cardPower!: CardPower

  @type("string") custom!: string

  constructor(
    cardSuit: CardSuit,
    cardPower: CardPower,
    custom = defaultCardSrc
  ) {
    super()

    const typeIndex = cardPower - cardMinimumValue
    if (typeIndex < 0 || typeIndex >= cardType.length)
      throw new Error(`Invalid card power: ${cardPower}`)

    this.cardType = cardType[typeIndex]
    this.cardPower = cardPower
    this.cardSuit = cardSuit
    this.custom = custom
  }

  override clone(): this {
    return new CardDataClass(this.cardSuit, this.cardPower, this.custom) as this
  }
}

export class CardWithPlayerClass extends CardDataClass {
  @type("string") playerId!: string

  constructor(
    cardSuit: CardSuit,
    cardPower: CardPower,
    playerId: string,
    custom = defaultCardSrc
  ) {
    super(cardSuit, cardPower, custom)
    this.playerId = playerId
  }

  override clone(): this {
    return new CardWithPlayerClass(
      this.cardSuit,
      this.cardPower,
      this.playerId,
      this.custom
    ) as this
  }
}

export type CardData = InstanceType<typeof CardDataClass>
export type CardWithPlayerData = InstanceType<typeof CardWithPlayerClass>
